(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jb-stock-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-stock-navigation')) {
    customElements.define('jb-stock-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const dropdowns = [...this.querySelectorAll('details')];
        const current = new URL(window.location.href);
        for (const link of this.querySelectorAll('[data-sort-value]')) {
          const target = new URL(current.href);
          target.searchParams.set('sort_by', link.dataset.sortValue);
          target.searchParams.delete('page');
          target.searchParams.delete('jb_view');
          target.hash = '';
          link.href = target.href;
        }
        for (const link of this.querySelectorAll('[data-colour-link]')) {
          const target = new URL(link.href, window.location.origin);
          target.search = '';
          target.hash = '';
          for (const [key, value] of current.searchParams) {
            if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') target.searchParams.append(key, value);
          }
          if (!target.searchParams.has('sort_by') && this.dataset.sortBy) target.searchParams.set('sort_by', this.dataset.sortBy);
          link.href = target.href;
        }
        const allLink = this.querySelector('[data-stock-view="all"]');
        if (allLink) {
          const target = new URL(current.href);
          target.searchParams.delete('filter.v.availability');
          target.searchParams.delete('page');
          target.searchParams.delete('jb_view');
          target.hash = '';
          allLink.href = target.href;
        }
        for (const details of dropdowns) {
          const summary = details.querySelector('summary');
          details.addEventListener('toggle', () => {
            if (details.open) {
              for (const other of dropdowns) if (other !== details) other.open = false;
            }
          }, { signal: this.controller.signal });
          document.addEventListener('pointerdown', (event) => {
            if (details.open && !details.contains(event.target)) details.open = false;
          }, { signal: this.controller.signal });
          details.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && details.open) {
              event.preventDefault();
              event.stopPropagation();
              details.open = false;
              summary?.focus();
            }
          }, { signal: this.controller.signal });
        }

      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
